/** This page will display events for a community that have not started yet. */

import { GetStaticPaths, GetStaticProps } from "next";
import { generateStaticCommunitySlugPaths } from "@dreambigger/communities/src/utils/static-paths-helper";
import CommunityEventsPage, {
  getCommunityEventsStaticProps,
} from "@dreambigger/communities/src/components/views/events";

// Get the static paths for each community that we want to prerender.
export const getStaticPaths: GetStaticPaths = generateStaticCommunitySlugPaths;

// Get the data we need to populate the events page with.
export const getStaticProps: GetStaticProps = getCommunityEventsStaticProps;

export default CommunityEventsPage;
